import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { initialBackgroundState } from "src/reducks/BackgroundStore/initializes";
import type { BackgroundItem } from "src/reducks/BackgroundStore/types";

export const backgroundSlice = createSlice({
  initialState: initialBackgroundState,
  name: "background",
  reducers: {
    addBackground: (state, action: PayloadAction<BackgroundItem>) => {
      if (state.selectedBackground.id !== action.payload.id) {
        state.selectedBackground.id = action.payload.id;
        state.selectedBackground.bought = action.payload.bought;
        state.selectedBackground.currentBackground =
          action.payload.currentBackground;
        state.selectedBackground.image = action.payload.image;
        state.selectedBackground.name = action.payload.name;
        state.selectedBackground.point = action.payload.point;
      } else {
        state.selectedBackground.id = state.initSelectedBackground.id;
        state.selectedBackground.bought = state.initSelectedBackground.bought;
        state.selectedBackground.currentBackground =
          state.initSelectedBackground.currentBackground;
        state.selectedBackground.image = state.initSelectedBackground.image;
        state.selectedBackground.name = state.initSelectedBackground.name;
        state.selectedBackground.point = state.initSelectedBackground.point;
      }
    },
    initSetBackground: (state, action: PayloadAction<BackgroundItem>) => {
      state.initSelectedBackground.id = action.payload.id;
      state.initSelectedBackground.bought = action.payload.bought;
      state.initSelectedBackground.currentBackground =
        action.payload.currentBackground;
      state.initSelectedBackground.image = action.payload.image;
      state.initSelectedBackground.name = action.payload.name;
      state.initSelectedBackground.point = action.payload.point;
    },
    resetBackground: (state) => {
      state.selectedBackground.id = "0";
      state.selectedBackground.image = "";
      state.selectedBackground.name = "";
      state.selectedBackground.point = 0;
    },
  },
});

export const { addBackground, initSetBackground, resetBackground } =
  backgroundSlice.actions;

export const backgroundReducer = backgroundSlice.reducer;
